 /*========================================================================================================================================================
  #                                                                GENERAL FUNCTIONS
==========================================================================================================================================================*/
// --------- DO something when the section has loaded, pass the section as param to the cb ---------
function waitForSectionToBeLoaded(target, callback) {
  const outerObserver = new MutationObserver((mutationsList, observer) => {
    const targetElement = document.querySelector(target);
    if (targetElement) {
      observer.disconnect(); 
      callback(targetElement);
    }
  });
  outerObserver.observe(document.documentElement, { childList: true, subtree: true });
}

// --------- DO something when the section has loaded , 2 nested target, empty cb param---------
function waitForSectionToBeLoaded2(parent, target, callback) {
  const outerObserver = new MutationObserver((mutationsList, observer) => {
    const parentElement = document.querySelector(parent);
    const targetElement = parentElement.querySelector(target);
    if (targetElement) {
      observer.disconnect(); 
      callback();
    }
  });
  outerObserver.observe(document.documentElement, { childList: true, subtree: true }); 
}

function sayHola(){
  console.log("hola-----------------")
}


const observer = new MutationObserver(() => {
    const watermark = document.querySelector('.tmenu-watermark');
    if (watermark) {
        watermark.remove();
        observer.disconnect(); // Deja de observar una vez que el elemento ha sido eliminado
    }
});

observer.observe(document.body, { childList: true, subtree: true });

/*========================================================================================================================================================
  #                                                                 CALENDARIO APP BUUNTO
==========================================================================================================================================================*/
function getSelectedDate(){
  let buuntoCalDay = document.querySelector('.buuntoCal-selected .buuntoCal-date');
  let buuntoCalmonth = document.querySelector('.buuntoCal-month');
  if (buuntoCalDay && buuntoCalmonth) {
    let date = buuntoCalDay.innerText + ' ' + buuntoCalmonth.innerText.split(' ')[0];  
    return date;
  } 
}

function addTextToCalendar(){
  let buuntoCalElement = document.querySelector('.buuntoCal');
  let selectedDate = getSelectedDate();

  if (selectedDate !== undefined) {
    let newDiv = document.createElement('div');
    newDiv.className = 'pango-calendar-extra-txt';
    newDiv.innerHTML = `Fecha seleccionada:<br> ${selectedDate}`;     
    buuntoCalElement.parentNode.insertBefore(newDiv, buuntoCalElement.nextSibling);
  }
  updateDateOnClick();
}

function updateDateTxt(){
  let pangoExtraElement = document.querySelector('.pango-calendar-extra-txt');
  let selectedDate = getSelectedDate()
  pangoExtraElement.innerHTML = `Fecha seleccionada:<br> ${selectedDate}`;  
}

function updateDateOnClick(){
  let calButtons= document.querySelectorAll('.buuntoCal-day')
  
  calButtons.forEach(btn => 
    btn.addEventListener('click', ()=> {
      let pangoExtraElement = document.querySelector('.pango-calendar-extra-txt');
      if (pangoExtraElement){
        updateDateTxt()
        setTimeout(()=> {
         updateDateTxt()
        }, 200)      
      } else {
        setTimeout(()=> {
         addTextToCalendar() 
        }, 200)            
      }    
    })
  )
}

waitForSectionToBeLoaded('.buuntoCal-week',addTextToCalendar)
/*========================================================================================================================================================
  #                                                            
==========================================================================================================================================================*/